<template lang="html">
  <Container hideGlow>
    <div class="video-container">
      <video
      autoplay
      loop
      playsinline
      muted="muted"
      name="video">
      <source src="../assets/video/axiox.mp4" type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'>
        <!-- <source src="../assets/video/axiox.ogv" type='video/ogg; codecs="theora, vorbis"'> -->
        <source src="../assets/video/axiox.webm" type='video/webm; codecs="vp8, vorbis"'>
          <img src="../assets/video/snapshoot.png">
        </video>
      </div>
  </Container>
</template>

<script>
import Container from '../components/Container.vue'

export default {
  components: { Container },
}
</script>

<style lang="css" scoped>
  @media screen and (max-width: 640px) {
    .video-container {
      height: calc(100vh - 80px);
    }
    .video-container video {
      height: 100%;
    }
  }

  @media screen and (min-width: 640px) {
    .video-container {
      height: 830px;
    }
    .video-container video {
      height: auto;
    }
  }

  .video-container {
    background-color: #18171a;
    width: 100%;
    /* height: calc(100vh - 100px); */
    overflow: hidden;
    position: relative;
    /* margin-top: 100px; */
  }
  .video-container video {
    min-width: 100%;
    /* min-height: 100%; */
    width: auto;
    position: absolute;
    /* top: 100px; */
    left: 50%;
    -webkit-transform: translateX(-50%) translateY(0%);
    transform: translateX(-50%) translateY(0%);
    overflow: hidden;
  }
</style>
